export const NON_EXISTING_OUTPUT_OPTION_DESCRIPTION = "Non-existing output";
